/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { TextFieldProps, FilledInputProps, InputLabelProps } from '@mui/material';
import { WrappedFieldProps } from 'redux-form';
import { InputField } from './InputField';
import { PriceNumericFormatCustom } from '../library/PriceField';

type Props = WrappedFieldProps &
  TextFieldProps & {
    hideHelperText?: boolean;
    errorWithoutTouch?: boolean;
    slotProps?: {
      input?: Partial<FilledInputProps>;
      inputLabel?: Partial<InputLabelProps>;
    };
  };

export const PriceField: React.FC<Props> = (props: Props) => (
  <InputField
    slotProps={{
      input: {
        inputComponent: PriceNumericFormatCustom as any,
      },
    }}
    {...props}
  />
);
